import * as Sentry from '@sentry/react';
import { useState, useEffect, type DependencyList } from 'react';
import axios, { type AxiosResponse } from 'axios';

// Custom hook for fetching data
export function useGet<T>(url: string | null, deps?: DependencyList, config?: Record<string, any>) {
  const [data, setData] = useState<T | null>(null); // State for data
  const [loading, setLoading] = useState(true); // State for loading
  const [error, setError] = useState(null); // State for error handling

  let dependencies: DependencyList = [url];
  if (deps != null) {
    dependencies = [...dependencies, ...deps];
  }

  useEffect(() => {
    const controller: AbortController = new AbortController();
    if (url != null && (deps == null || deps?.every((dep) => dep != null))) {
      setLoading(true);
      axios
        .get<T>(url, { ...config, signal: controller.signal })
        .then((response: AxiosResponse<T>) => {
          setData(response.data);
          setLoading(false);
        })
        .catch((err) => {
          if (axios.isCancel(err)) return;
          setLoading(false);
          setError(err);
          Sentry.captureException(err);
        });
    }
    return () => controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies); // Dependency array with url

  return { data, loading, error };
}
